import * as React from 'react'

import { NotFound } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useShiftManagementModuleAvailability } from 'modules/shift_management/hooks/useShiftManagementModuleAvailability'
import shiftTemplates from 'modules/shift_management/store/api/collections/shiftTemplates'
import type ShiftTemplate from 'modules/shift_management/store/api/models/ShiftTemplate'

import BasicInfo from './BasicInfo'
import WeekSection from './WeekSection'

interface ContentProps {
  shiftTemplate: ShiftTemplate | null | undefined
}

const Content = ({ shiftTemplate }: ContentProps) => {
  if (!shiftTemplate) return null

  return (
    <>
      <BasicInfo shiftTemplate={shiftTemplate} />
      <WeekSection shiftTemplate={shiftTemplate} />
    </>
  )
}

interface UseFetchDataType {
  loading: boolean
  isNotFound: boolean
  shiftTemplate: ShiftTemplate | null | undefined
}

function useFetchData(shiftTemplateId: string): UseFetchDataType {
  const { isNotFound, isModuleLoading } = useShiftManagementModuleAvailability()
  const { loading } = useAsyncData(() => shiftTemplates.fetch(), [])

  const attr = {
    id: shiftTemplateId,
  }

  const shiftTemplate = !loading ? shiftTemplates.find(attr) : null

  return {
    loading: loading || isModuleLoading,
    shiftTemplate,
    isNotFound,
  }
}

interface Props {
  shiftTemplateId: string
}

function EditShiftTemplate({ shiftTemplateId }: Props) {
  const { loading, isNotFound, shiftTemplate } = useFetchData(shiftTemplateId)

  if (loading) {
    return <Loading />
  }

  if (isNotFound) {
    return (
      <NotFound
        title={i18n.t('errors.page_not_found.title')}
        description={i18n.t('errors.page_not_found.description')}
      />
    )
  }

  return (
    <ResponsivePage.Body showHeader={false}>
      <Content shiftTemplate={shiftTemplate} />
    </ResponsivePage.Body>
  )
}

export default observer(EditShiftTemplate)
